import { tnl } from '@i18nApp/i18n';

export const formOptions = (options) =>
  options.map((option) => ({ label: tnl(option), value: option }));

export const emptyInputOptions = ['', undefined, null];
